export default {
  WORK_CREATE: 'สร้างงาน',
  WORK_COLLAB: 'มีส่วนร่วมกับงาน',
  WORK_ACCEPT: 'รับงาน',
  USER_CREATE: 'สร้างผู้ใช้',
  USER_EDIT: 'แก้ไขผู้ใช้',
  SYSTEM_EDIT: 'แก้ไขข้อมูลระบบ',
  OTHERS: 'อื่นๆ',
};
